import React from "react";
import { Col, Layout, Row, Space, Spin, Typography } from "antd";
import Page, { PageProps } from "../../../core/ui/pages/Page";
import { ICaseDecisionPresenter } from "../../presenter/CaseDecisionPresenter";
import CaseDecisionList from "../components/CaseDecisionList";
import SearchCriteriaForm from "../../../search/ui/components/SearchCriteriaForm";
const { Content, Sider } = Layout;
const { Title } = Typography;

export interface Props extends PageProps {}

export interface State extends ICaseDecisionPresenter {}

export default class CaseDecisionPage extends React.Component<Props, State> {
  private subscriptionId: number = 0;

  constructor(props: any) {
    super(props);
    this.state = { ...props };
  }

  componentDidMount() {
    this.subscriptionId = this.state.store.subscribe((result) => {
      return this.setState((prevState) => result);
    });
  }

  componentWillUnmount() {
    this.state.store.unsubscribe(this.subscriptionId);
  }

  render() {
    const {
      translate,
      caseDecisionList,
      createCaseDecision,
      findCourtCaseDetails,
      courtCase,
      getAllCaseDecisionTypeIndexes,
      setCaseDecisionTypeId,
      setOrganisationId,
      selectedOrganisationId,
      organisations,
      caseDecisionTypes,
      caseDecisionTypeOrganisationIndex,
      selectedCaseDecisionTypeId,
      selectedOrganisationIndexIds,
      createModalVisible,
      onChangeCreateModalVisible,
      user,
      showCaseDecisionDetails,
      store,
      application,
      showCaseDecisionCreation
    } = this.state;

    return (
      <Page {...this.props}>
        {
          <Spin spinning={this.state.loaders.caseDecisionLoader}>
            <Layout>
              <Sider
                className={"content-container dashboard-sider search-sider"}
                breakpoint="xl"
                collapsible
                collapsedWidth="0"
                width={"22%"}
              >
                <SearchCriteriaForm
                  user={user}
                  translate={translate}
                  organisations={organisations}
                  showStatusFilter={!application.isPortal()}
                />
              </Sider>
              <Layout className={"dashboard-content-wrapper"}>
                <Content className="site-layout-background dashboard-content-container">
                  <Row gutter={[0, 16]}>
                    <Col xs={24} sm={24}>
                      <Space size={"large"} align="center">
                        <Title level={1}>
                          {translate("editors.case_decisions.title")}
                        </Title>
                      </Space>
                    </Col>
                  </Row>
                  <CaseDecisionList
                    user={user}
                    translate={translate}
                    caseDecisionList={caseDecisionList}
                    createCaseDecision={createCaseDecision}
                    findCourtCaseDetails={findCourtCaseDetails}
                    courtCase={courtCase}
                    getAllCaseDecisionTypeIndexes={
                      getAllCaseDecisionTypeIndexes
                    }
                    setCaseDecisionTypeId={setCaseDecisionTypeId}
                    setOrganisationId={setOrganisationId}
                    selectedOrganisationId={selectedOrganisationId}
                    organisations={organisations}
                    caseDecisionTypes={caseDecisionTypes}
                    caseDecisionTypeOrganisationIndex={
                      caseDecisionTypeOrganisationIndex
                    }
                    selectedCaseDecisionTypeId={selectedCaseDecisionTypeId}
                    selectedOrganisationIndexIds={selectedOrganisationIndexIds}
                    createModalVisible={createModalVisible}
                    onChangeCreateModalVisible={onChangeCreateModalVisible}
                    showCaseDecisionDetails={showCaseDecisionDetails}
                    store={store}
                    showCaseDecisionCreation={showCaseDecisionCreation}
                  />
                </Content>
              </Layout>
            </Layout>
          </Spin>
        }
      </Page>
    );
  }
}
